import { CustomizableValidator } from '../../types/Validator';
import { validateLandLine } from './validateLandLine';
import { validateMobilePhone } from './validateMobilePhone';

interface PhoneValidatorConfig {
  landLine?: boolean;
  mobile?: boolean;
}

const getError = (validationResult: any) => {
  if (validationResult && validationResult.errorCode) {
    return { errorCode: validationResult.errorCode };
  }
  return undefined;
};

export const validatePhone: CustomizableValidator<PhoneValidatorConfig> = ({
  landLine,
  mobile
}) => (...validatorArgs) => {
  const landLineValidation = landLine
    ? validateLandLine(...validatorArgs)
    : undefined;
  const mobileValidation = mobile
    ? validateMobilePhone(...validatorArgs)
    : undefined;

  if (landLine && mobile) {
    const bothFail = Boolean(landLineValidation && mobileValidation);
    return bothFail
      ? getError(landLineValidation || mobileValidation)
      : undefined;
  }

  if (landLine) {
    return getError(landLineValidation);
  }

  if (mobile) {
    return getError(mobileValidation);
  }
};
